<ng-container *ngIf="vm$ | async as vm">
  <div class="form-panel">
    <dgx-dfb-form
      [fieldset]="vm.fieldDef"
      [form]="vm.formGroup"
      [validate]="vm.validate"
      [hasPlumbingAndDrainage]="hasPlumbingAndDrainage"
      (analytics)="handleAnalytics($event)"
    >
    </dgx-dfb-form>
  </div>
</ng-container>
